import axios from 'axios'

const unprovisionedProfile = {
  /**
   * Fetches the bulk profile, including BAI/BII data
   *
   * ~~Binds address and consumer details with the given card.~~
   * ~~Assigns the given country code to the addresses.~~
   *
   * @param {Object} payload
   * @returns {Promise<Object>}
   */
  // TODO: rename this function
  updateProfile(payload) {
    return axios.post('/api/unprovisioned-profile', payload)
  },

  /**
   * Delete unprovisioned profile and the pending card if it has already been tokenized
   *
   * @param {String} srcDigitalCardId
   * @param {String} cardAuthToken
   * @returns {Promise<Object>}
   */
  deleteCard(srcDigitalCardId, cardAuthToken) {
    const headers = {
      'X-SRC-CARD-TOKEN': cardAuthToken
    }

    return axios.delete(`/api/unprovisioned-profile/${srcDigitalCardId}`, { headers })
  }
}

export default unprovisionedProfile
